import React from 'react';
import './Home.css';
function Skills() {
  return (
    <section id="skills">
      <h2>Skills</h2>
      <p>
        <b>Programming Languages: </b>Proficient foundational in Java and Python<br></br>

        <b>Web Development:</b> Experience with HTML, CSS, React, and Node.js to build dynamic and responsive web applications.<br></br>

        <b>Database Management: </b>Familiar with SQL and NoSQL databases, including MySQL and MongoDB.<br></br>

        <b>Version Control:</b> Skilled in using Git for version control and collaboration on projects.</p>
    </section>
  );
}

export default Skills;
